import {
    Alert, Box, Grid, IconButton, Card, CardContent, CardHeader,
    TextField, Button, Collapse,
    FormControl,
    InputLabel,
    OutlinedInput,
    InputAdornment
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSearchParams } from 'react-router-dom';
import jwt_decode from "jwt-decode";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export default function EstablecerPassword() {
    const [searchParams] = useSearchParams();    
    const token = searchParams.get('token');
    const decoded = jwt_decode(token);
    const id = decoded.id;
    //sessionStorage.setItem('token', token)
    const [usuario, setUsuario] = useState({
        id,
        password: ''
    })

    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(true);
    const [severity, setSeverity] = useState('info')  
    const [mensaje, setMensaje] = useState('Después de establecer tu contraseña, inicia sesión. Por favor incluye en tu contraseña al menos una letra mayúscula, al menos una letra minúscula, un número y un caracter especial (no alfanumérico). La longitud mínima aceptada es de 8 caracteres.');
    const navigate = useNavigate()

    const [showPassword, setShowPassword] = useState(false);
    const togglePassword = () => setShowPassword((showPassword) => !showPassword);

    const handleSubmit = async (e) => {
        e.preventDefault()

        setLoading(true)
        console.log(`usuario: ${JSON.stringify(usuario)}`)

       const res= await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/auth/registrarAlumno`, {
            method: "POST",
            body: JSON.stringify(usuario),
            headers: { "Content-Type": "application/json", "x-access-token": token },
        })
        const respuesta= await res.json()
        console.log(`res.status ${res.status}`)
        if(res.status === 403)
        {
            setSeverity('error')
            setMensaje(respuesta.message)
            setOpen(true)
            setLoading(false)
        }
        if(res.status === 200){
            //sessionStorage.clear()
            setSeverity('success')
            setMensaje(<span>
                <strong>¡Felicitaciones!</strong> Has completado exitosamente el proceso de creación de tu cuenta. Accede ahora a NADU 2.0 a través de este enlace: <br/>
                <a href="/auth/login" style={{ color: 'blue', textDecoration: 'underline' }}>
                http://{process.env.REACT_APP_HOST}:{process.env.REACT_APP_FRONTEND_PORT}/auth/login
                </a>.
              </span>)            
            //navigate('/')
            setOpen(true)
            setLoading(false)
        }
    }

    const handleChange = e => {
        setUsuario({ ...usuario, [e.target.name]: e.target.value })
        //copio todo lo que tenga el usuario y luego actualizo lo que se está tecleando
    }
    return (

        <Grid container direction='row' justifyContent='center' style={{ marginTop: 50 }}>
            <Grid item xs={12}>
                <Card>
                    <CardHeader title='Registro de usuario y contraseña'></CardHeader>
                    <CardContent>
                        <form onSubmit={handleSubmit}>
                            <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                                <Grid item xs={12} sm={12}>
                                    <TextField label='Matrícula' name='id' onChange={handleChange} value={usuario.id} style={{width: '100%'}} disabled/>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                     <FormControl sx={{ width: '100%' }} variant="outlined">
                                        <InputLabel htmlFor="password">Escribe una contraseña</InputLabel>
                                        <OutlinedInput id='password'
                                            name='password' onChange={handleChange} value={usuario.password}
                                            type={showPassword ? 'text' : 'password'}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={togglePassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            label="Escriba su nuevo password"
                                        />
                                    </FormControl>
                                    {/*<TextField label='Escribe una contraseña' name='password' type="password" onChange={handleChange} value={usuario.password} style={{width: '100%'}}/>*/}
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <Button variant='contained' color='primary' type='submit' style={{ marginTop: 20 }} disabled={!usuario.id || !usuario.password || loading}>
                                        Enviar
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                        <Box sx={{ width: '100%' }}>
                            <Collapse in={open}>
                                <Alert severity={severity}
                                    action={
                                        <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                                setOpen(false);
                                            }}
                                        >
                                            <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                    }
                                    style={{ marginTop: 30  }}
                                >
                                    {mensaje}
                                </Alert>
                            </Collapse>
                        </Box>
                    </CardContent>
                </Card>

            </Grid>
        </Grid>
    )
}